import * as React from "react";
const SvgChevronleftG900 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path stroke="#191919" strokeLinecap="round" strokeLinejoin="round" d="M11 4 6 9l5 5" />
  </svg>
);
export default SvgChevronleftG900;
